import useApiCall, {ApiCallResponseData, makeApiCall} from "../hooks/CancellableApiCall";
import {
    Alert, Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Snackbar,
    Stack,
    Typography
} from "@mui/material";
import {LoadingContent} from "../components/LoadingContent";
import React, {useCallback, useState} from "react";
import {AwardResponse} from "../data/AwardResponse";
import {useNavigate} from "react-router-dom";

interface DeleteAwardPageProps {
    awards: AwardResponse[],
    refresh: () => void,
}

type alertType = "success" | "error" | "info"

function DeleteAwardPageContent(props: DeleteAwardPageProps) {
    const [awardIdx, setAwardIdx] = useState<number | null>(null)
    const award = awardIdx != null ? props.awards.at(awardIdx) : null
    const [apiCall, setApiCall] = useState<ApiCallResponseData>()
    const navigate = useNavigate()
    const [showAlert, setShowAlert] = useState(false)
    const [alertType, setAlertType] = useState<alertType>("success")
    const [alertText, setAlertText] = useState("")

    const setAlert = useCallback((type: alertType, text: string) => {
        setAlertType(type)
        setAlertText(text)
        setShowAlert(true)
    }, [setAlertType, setAlertText, setShowAlert])

    const cancelOldApiCall = useCallback(() => {
        apiCall?.cancel()
    }, [apiCall])

    const deleteAward = (awardId: number) => {
        cancelOldApiCall()
        setApiCall(makeApiCall({
            url: `/api/awards/${awardId}`,
            method: "DELETE",
            redirectOnUnauthorized: navigate,
            onLoadedCallback: () => {
                setAlert("success", "Deleted award")
                props.refresh()
                setAwardIdx(null)
            },
            onError: () => {
                setAlert("error", "An error deleting an award")
            }
        }))
    }

    return <Box sx={{width:"100%"}}>
        <Typography variant={"h6"} gutterBottom>Delete Award</Typography>
        <Paper variant={"outlined"} style={{
            width:"100%",
            padding: "16px"
        }}>
            <Stack spacing={1}>
                <FormControl>
                    <InputLabel id="award-select-label">Award</InputLabel>
                    <Select id="award-select" value={awardIdx} label="Award" onChange={(event) => {
                        setAwardIdx(event.target.value as number)
                    }}>
                        {props.awards.map((award, idx) =>
                            <MenuItem key={award.name} value={idx}>{award.name}</MenuItem>
                        )}
                    </Select>
                </FormControl>
                <Button disabled={!award} variant="contained" color={"error"} onClick={() => {
                    if (award) {
                        deleteAward(award.id)
                    }
                }}>
                    Delete Award (THERE IS NO CONFIRMATION BE REALLY CAREFUL!!!)
                </Button>
                <Snackbar open={showAlert} autoHideDuration={5000} onClose={() => setShowAlert(false)}>
                    <Alert severity={alertType} onClose={() => setShowAlert(false)} sx={{width: "100%"}} variant="filled">
                        {alertText}
                    </Alert>
                </Snackbar>
            </Stack>
        </Paper>
    </Box>
}

export const DeleteAwardPage = () => {
    const loadAwards = useApiCall<AwardResponse[]>({
        initialUrl: "/api/awards"
    })

    return (
        <>
            <LoadingContent isLoading={loadAwards.isLoading}>
                <Stack spacing={{xs: 2, sm: 4}} direction="row" useFlexGap flexWrap="wrap">
                    <DeleteAwardPageContent awards={loadAwards.data!!} refresh={loadAwards.refresh}/>
                </Stack>
            </LoadingContent>
        </>
    )
}